export default {
  components: {
    HeaderBlock: () => import('~/components/commom/header'),
    FooterBlock: () => import('~/components/commom/footer')
  },
  data() {
    return {
      contentOptions: [
        'Privacy policy',
        'General terms and conditions of use',
        'Cookie Policy'
      ]
    }
  },
  methods: {
    converToKebabCase(string) {
      return string.replace(/\s+/g, '-').toLowerCase()
    }
  }
}
